module.exports = __webpack_public_path__ + "img/ess_e.245a9f72.jpg";